import { UtilsService } from './../../../../services/utils.service';
import { Category } from './../../../generics/data-printer/data-printer.component';
import { Broker } from './../../../../models/broker.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-broker-details-content',
  templateUrl: './broker-details-content.component.html',
  styleUrls: ['./broker-details-content.component.scss']
})
export class BrokerDetailsContentComponent implements OnInit {

    private brokerContent?: Broker;
    @Input()
    set broker(br: Broker) {
        this.brokerContent = br;
        this.updateCategories();
    }
    get broker() {
        return this.brokerContent;
    }

    categories: Category[] = [];

    constructor(
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
    }

    updateCategories() {
        if (!this.broker) return;
        this.categories = [
            { name: 'Información general', items: [
                { label: 'Nombre', value: this.broker.nombre },
                { label: 'Apellido', value: this.broker.apellido },
                { label: 'Teléfono', value: this.broker.celular, type: 'phone' },
                { label: 'CUIT', value: this.broker.cuit, type: 'cuit' },
            ]}
        ];
    }
}
